import { render, staticRenderFns } from "./TeacherInfo.vue?vue&type=template&id=1c0d580c&scoped=true"
import script from "./TeacherInfo.vue?vue&type=script&lang=js"
export * from "./TeacherInfo.vue?vue&type=script&lang=js"
import style0 from "./TeacherInfo.vue?vue&type=style&index=0&id=1c0d580c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d580c",
  null
  
)

export default component.exports